import React from "react";
import Meta from "../components/Meta";

const About = () => {
  // Schema markup for structured data
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About VEDA Merchandise",
    "description": "Learn about VEDA Merchandise, our mission to educate children through mythological toys, games, and puzzles.",
    "url": "https://vedamerchandise.com/about",
    "publisher": {
      "@type": "Organization",
      "name": "VEDA Merchandise",
      "logo": {
        "@type": "ImageObject",
        "url": "https://vedamerchandise.com/logo.svg"
      }
    }
  };

  return (
    <>
      <Meta 
        title="About VEDA Merchandise - Educational Mythological Toys & Games"
        description="Learn about VEDA Merchandise, our mission to educate children through mythological toys, games, and puzzles."
        keywords="about VEDA, mythological toys company, educational games manufacturer, Indian mythology toys"
        author="VEDA Merchandise"
        ogTitle="About VEDA Merchandise - Educational Mythological Toys & Games"
        ogDescription="Learn about VEDA Merchandise, our mission to educate children through mythological toys, games, and puzzles."
        ogImage="https://vedamerchandise.com/about-preview.jpg"
        ogUrl="https://vedamerchandise.com/about"
        ogType="website"
        twitterCard="summary_large_image"
        twitterTitle="About VEDA Merchandise - Educational Mythological Toys & Games"
        twitterDescription="Learn about VEDA Merchandise, our mission to educate children through mythological toys, games, and puzzles."
        twitterImage="https://vedamerchandise.com/about-preview.jpg"
        robots="index, follow"
        canonicalUrl="https://vedamerchandise.com/about"
        schemaMarkup={schemaMarkup}
      />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-8 text-red-600">About VEDA</h1>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">Our Mission</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              At VEDA, we believe in the power of storytelling to educate and inspire. Our mission is to bring the rich tapestry of Indian mythology to life through engaging toys, games, and puzzles that not only entertain but also educate children about their cultural heritage.
            </p>
            
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">What We Offer</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              We offer a carefully curated collection of mythological toys, interactive games, and challenging puzzles that are designed to:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
              <li>Introduce children to the fascinating world of Indian mythology</li>
              <li>Develop cognitive skills through engaging gameplay</li>
              <li>Instill values and life lessons from ancient epics</li>
              <li>Encourage creativity and imagination</li>
              <li>Provide hours of educational entertainment</li>
            </ul>
            
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">Our Values</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              We are committed to creating products that are not only fun but also safe, durable, and environmentally responsible. Our team works tirelessly to ensure that every product meets the highest quality standards while staying true to the essence of the stories they represent.
            </p>
          </div>
          
          <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-2xl shadow-lg p-8 text-white text-center">
            <h2 className="text-3xl font-bold mb-4">Join Our Journey</h2>
            <p className="text-xl mb-6">
              Discover the magic of Indian mythology with VEDA
            </p>
            <a 
              href="/products" 
              className="inline-block bg-white text-red-600 font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition-colors duration-300"
            >
              Explore Our Collection
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;